import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useCDK } from './useCdk';
import { useSignIntoLocation } from 'lib/api/locations/signIntoLocation';
import { useAuth } from 'lib/context';

// for some reason browser translate cdkStoreId into cdkstoreId
const PARAM_CDK_STORE_ID = 'cdkstoreId';

export function useCdkStoreIdLoginGuardHardReload() {
  const { isCdkUser } = useCDK();

  const reportsPath = '/reports/overview';

  const { locations, userData, invalidateUser } = useAuth();
  const location = useLocation();
  const history = useHistory();
  const [isChecking, setIsChecking] = useState(isCdkUser);
  const { mutateAsync: signIn } = useSignIntoLocation();

  const searchParams = new URLSearchParams(location.search);
  const cdkStoreIdParam = searchParams.get(PARAM_CDK_STORE_ID);
  const cdkStoreId = cdkStoreIdParam !== null ? cdkStoreIdParam : '';

  const handleCdkLogin = useCallback(
    async (locationId: number) => {
      try {
        await signIn({ locationId });

        // Mark as logged & remember storeId
        await invalidateUser();
        history.replace(reportsPath);
        setIsChecking(false);
      } catch {
        setIsChecking(false);
      }
    },
    [reportsPath, location.search, signIn]
  );

  useEffect(() => {
    if (!userData?.isMultiLocation) {
      return setIsChecking(false);
    }

    if (!isCdkUser) {
      return setIsChecking(false);
    }

    if (!cdkStoreId) {
      return setIsChecking(false);
    }

    const currentLocation = locations?.find(
      loc => loc.cdkStoreId === cdkStoreId
    );

    if (!currentLocation) {
      return setIsChecking(false);
    }

    handleCdkLogin(currentLocation.locationId);
  }, [isCdkUser, cdkStoreId, cdkStoreId, locations, handleCdkLogin]);

  const isCdkStoreContextPresent = (): true | null => {
    try {
      return isCdkUser && cdkStoreId ? true : null;
    } catch {
      return null;
    }
  };

  return { isLoading: isChecking, isCdkStoreContextPresent };
}
